import { Modal } from "antd";
import { ProfileOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";

import CompareModalHeader from "../../components/generic/CompareModalHeader";
import FileToSpecView from "./view/FileToSpecView";
import FileToDbView from "./view/FileToDbView";
import FileToFileView from "./view/FileToFileView";
import DbToDbView from "./view/DbToDbView";
import EventMonitorView from "./view/EventMonitorView";
import FileMoveView from "./view/FileMoveView";
import FileExtractionView from "./view/FileExtractionView";
import { getMapping } from "../../service/db.service";
import {
  labelForCategory,
  labelForSubCategory,
} from "../../constants/reconciliationLabels";
import "../../styles/viewDetail.css";

export default function TaskViewModal(props) {
  const [mappingDetail, setMappingDetail] = useState([]);
  useEffect(() => {
    if (props.data.mappingName) {
      getMapping(props.data.mappingName).then((res) => {
        setMappingDetail(res.data);
      });
    }
  }, [props.data.mappingName]);

  // Registry of sub-category views — no switch statements.
  const VIEWS = {
    "File to Specification": (
      <FileToSpecView
        testSuite={props.data.suiteName || ""}
        matchType={props.data.matchType || ""}
        fileName={props.data.fileName || ""}
      />
    ),
    "File to Database": (
      <FileToDbView
        testSuite={props.data.suiteName || ""}
        matchType={props.data.matchType || ""}
        fileName={props.data.fileName || ""}
        delimiter={props.data.delimiter || ""}
        mappingName={props.data.mappingName || ""}
        mappingDetail={mappingDetail}
      />
    ),
    "File to File": (
      <FileToFileView
        matchType={props.data.matchType || ""}
        fileName={props.data.fileName || ""}
        delimiter={props.data.delimiter || ""}
        matchTypeTwo={props.data.matchTypeTwo || ""}
        fileNameTwo={props.data.fileNameTwo || ""}
        delimiterTwo={props.data.delimiterTwo || ""}
        mappingName={props.data.mappingName || ""}
        mappingDetail={mappingDetail}
      />
    ),
    "Database to Database": (
      <DbToDbView
        testSuite={props.data.suiteName || ""}
        testSuiteTwo={props.data.suiteNameTwo || ""}
        mappingName={props.data.mappingName || ""}
        mappingDetail={mappingDetail}
      />
    ),
    "Event Monitor": (
      <EventMonitorView
        matchType={props.data.processMatch || ""}
        fileName={props.data.processFileName}
        eventType={props.data.eventType || ""}
      />
    ),
    "File Move, Copy or Delete": (
      <FileMoveView
        matchType={props.data.processMatch || ""}
        fileName={props.data.processFileName}
        eventType={props.data.eventType || ""}
      />
    ),
    "Extract Compressed File": (
      <FileExtractionView
        matchType={props.data.processMatch || ""}
        fileName={props.data.processFileName}
      />
    ),
  };

  return (
    <div>
      <Modal
        open={props.isOpen}
        destroyOnClose
        maskClosable={false}
        centered
        width={640}
        footer={null}
        onCancel={props.handleModal}
      >
        <CompareModalHeader
          icon={<ProfileOutlined />}
          title={props.data.taskName || "Task"}
          subtitle="Task details"
        />
        <div className="vd-panel">
          <div className="vd-row">
            <span className="vd-label">Type</span>
            <span className="vd-tags">
              {props.data.taskCategory && (
                <span className="vd-tag">
                  {labelForCategory(props.data.taskCategory)}
                </span>
              )}
              {props.data.taskSubCategory && (
                <span className="vd-tag">
                  {labelForSubCategory(props.data.taskSubCategory)}
                </span>
              )}
            </span>
          </div>
          {VIEWS[props.data.taskSubCategory] ?? null}
        </div>
      </Modal>
    </div>
  );
}
